import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export default function BottomToTop({
    children,
    fromY = 50,        // Starting Y offset (positive means below; negative means above)
    toY = 0,           // Ending Y offset
    fromOpacity = 0,   // Starting opacity
    toOpacity = 1,     // Ending opacity
    duration = 0.5,    // Animation duration in seconds
    ease = 'easeInOut',// Easing function
    delay = 0          // Delay before animation starts
}) {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= 860 : false
    );

    useEffect(() => {
        const onResize = () => {
            setIsMobile(window.innerWidth <= 860);
        };

        window.addEventListener('resize', onResize, { passive: true });
        return () => window.removeEventListener('resize', onResize);
    }, []);

    if (isMobile) {
        return <div>{children}</div>;
    }

    return (
        <motion.div
            initial={{ y: fromY, opacity: fromOpacity }}
            animate={{ y: toY, opacity: toOpacity }}
            transition={{
                duration,
                ease,
                delay
            }}
        >
            {children}
        </motion.div>
    );
}
